import type { Battle, BattleActor, BattleRound } from '@mezha/api'
import { roundLines } from './words'

/** A resolved round in words; `short` keeps the first two lines (phones). */
export function RoundLog({ round, actors, short, skills }: { round: BattleRound; actors: BattleActor[]; short?: boolean; skills?: Record<string, string> }) {
  const lines = roundLines(round, actors, skills)
  const shown = short ? lines.slice(0, 2) : lines
  return (
    <>
      <p><b>Раунд {round.round}.</b>{lines.length === 0 ? ' Оба выжидали.' : ''}</p>
      {shown.map((l, i) => (
        <p key={i}>{l.map((part, j) => (part.tone ? <span key={j} className={part.tone}>{part.text}</span> : <span key={j}>{part.text}</span>))}</p>
      ))}
    </>
  )
}

/** Every resolved round, newest first, with the seed hash (the seed opens after the end). */
export function FullLog({ battle: b }: { battle: Battle }) {
  const rounds = [...b.log].reverse()
  return (
    <div className="fulllog">
      {rounds.length === 0 && <p className="note">Раундов ещё не было.</p>}
      {rounds.map(r => (
        <div key={r.round} className="roundlog parch">
          <RoundLog round={r} actors={b.actors} skills={b.skill_names} />
        </div>
      ))}
      <p className="note fulllog__seed">Отпечаток зерна боя: <code>{b.seed_hash}</code>{b.result?.seed ? <> · зерно: <code>{b.result.seed}</code></> : ' · зерно откроется после боя'}</p>
    </div>
  )
}

